/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compliance_VatInputs */

const tr_pricing_compliance_vat = /** @type {(inputs: Pricing_Compliance_VatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyatlara KDV dahildir.`)
};

const en_pricing_compliance_vat = /** @type {(inputs: Pricing_Compliance_VatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices include KDV (VAT).`)
};

const de_pricing_compliance_vat = /** @type {(inputs: Pricing_Compliance_VatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise inkl. KDV (MwSt).`)
};

const ru_pricing_compliance_vat = /** @type {(inputs: Pricing_Compliance_VatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены включают KDV (НДС).`)
};

/**
* | output |
* | --- |
* | "Prices include KDV (VAT)." |
*
* @param {Pricing_Compliance_VatInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compliance_vat = /** @type {((inputs?: Pricing_Compliance_VatInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compliance_VatInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_compliance_vat(inputs)
	if (locale === "de") return de_pricing_compliance_vat(inputs)
	if (locale === "ru") return ru_pricing_compliance_vat(inputs)
	return tr_pricing_compliance_vat(inputs)
});